/**
 * Human labels for panel ids. The engine lower-cases panel group ids
 * (`leftsleevepanel`, `innerpanels`, `Noncustomizable-necktape`), which reads
 * badly in a checklist a factory worker has to scan. Split on the garment
 * vocabulary we know, drop the `panel` suffix, title-case the rest; anything
 * unknown is shown as spelled.
 */
const WORDS = [
  'left',
  'right',
  'front',
  'back',
  'inner',
  'outer',
  'upper',
  'lower',
  'sleeve',
  'sleeves',
  'collar',
  'neck',
  'tape',
  'yoke',
  'side',
  'cuff',
  'cuffs',
  'hood',
  'pocket',
  'placket',
  'waist',
  'band',
  'hem',
  'gusset',
  'panel',
  'panels',
];

/** Greedy dictionary split; null when the token is not fully covered. */
function segment(token: string): string[] | null {
  const out: string[] = [];
  let rest = token;
  while (rest.length) {
    const hit = WORDS.filter((w) => rest.startsWith(w)).sort((a, b) => b.length - a.length)[0];
    if (!hit) return null;
    out.push(hit);
    rest = rest.slice(hit.length);
  }
  return out;
}

function titleCase(word: string): string {
  return word.charAt(0).toUpperCase() + word.slice(1);
}

export function prettyPanelName(id: string): string {
  const cleaned = id.trim();
  if (!cleaned) return '';
  const words: string[] = [];
  for (const part of cleaned.split(/[-_\s]+/).filter(Boolean)) {
    const known = segment(part.toLowerCase());
    if (known) words.push(...known.filter((w) => !/^panels?$/.test(w)).map(titleCase));
    else words.push(part);
  }
  return words.length ? words.join(' ') : titleCase(cleaned);
}
